import React from 'react';
import GroupsAvailability from '../pages/GroupsAvailability';

export const groupsAvailabilityRoutePage = {
  component: <GroupsAvailability />,
  route: '/disponibilidade-dos-grupos',
};
